export const environment = {
  production: true,
  webservice: 'https://webservice.economico.preprod.eng.c-alm.ch',
  clientName: 'MarketIFrame',
  clientOrigin: 'https://marketframe.economico.preprod.eng.c-alm.ch',
  iframeParentOrigin: 'https://finport.saas.preprod.eng.c-alm.ch'
};
